import React, { useState, useContext } from 'react';
import { Box, Typography, useTheme, Snackbar } from '@mui/joy';
import CustomInput from "../../components/UI/custom_elements/customInput";
import PrimaryButton from "../../components/UI/custom_elements/primaryButton";
import SessionContext from "../../store";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const ChangePasswordRequired = () => {
    const theme = useTheme();
    const { session } = useContext(SessionContext);
    const navigate = useNavigate();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const handleChangePassword = async () => {
        if (!newPassword.trim()) {
            setErrorMessage('Por favor ingrese la nueva contraseña');
            return;
        }

        if (newPassword !== confirmPassword) {
            setErrorMessage('Las contraseñas no coinciden');
            return;
        }

        if (newPassword.length < 6) {
            setErrorMessage('La contraseña debe tener al menos 6 caracteres');
            return;
        }

        setLoading(true);
        setErrorMessage('');
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_URL_API}/orders/update-password`,
                {
                    password: newPassword,
                    token: session.token
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${session.token}`
                    }
                }
            );

            if (response.status === 200) {
                setSuccessMessage('Contraseña actualizada exitosamente');
                setTimeout(() => {
                    navigate('/');
                }, 2000);
            }
        } catch (error) {
            if (error.response && error.response.status === 400) {
                setErrorMessage('Error al actualizar la contraseña. Por favor intente nuevamente.');
            } else {
                setErrorMessage('Error al actualizar la contraseña');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box 
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: theme.vars.palette.background.body, 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 3,
                overflowX: 'hidden',
                overflowY: 'hidden'
            }}
        >
            <Snackbar
                open={!!errorMessage}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                variant="solid"
                color="danger"
                autoHideDuration={4000}
                onClose={() => setErrorMessage('')}
            >
                {errorMessage}
            </Snackbar>

            <Snackbar
                open={!!successMessage}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                variant="solid"
                color="success"
                autoHideDuration={4000}
                onClose={() => setSuccessMessage('')}
            >
                {successMessage}
            </Snackbar>

            <Box sx={{
                width: "100%",
                maxWidth: "500px",
                backgroundColor: theme.vars.palette.background.surface,
                borderRadius: '12px',
                p: 4,
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                overflow: 'hidden',
                '&::-webkit-scrollbar': { display: 'none' },
                scrollbarWidth: 'none',
                msOverflowStyle: 'none'
            }}>
                <Typography sx={{
                    fontFamily: "Montserrat",
                    fontSize: "24px",
                    fontWeight: 700,
                    color: theme.vars.palette.primary["500"],
                    mb: 1
                }}>
                    Cambio de Contraseña Requerido
                </Typography>

                <Typography sx={{
                    fontFamily: "Montserrat",
                    fontSize: "14px",
                    color: theme.vars.palette.text.main,
                    mb: 4
                }}>
                    Por seguridad, debe cambiar su contraseña antes de continuar.
                </Typography>

                <Box mt={3}>
                    <Typography mb={1} sx={{
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                        fontWeight: 500,
                        color: theme.vars.palette.text.main
                    }}>
                        Nueva Contraseña
                    </Typography>
                    <CustomInput
                        placeholder="Ingrese la nueva contraseña"
                        width="100%"
                        password={true}
                        value={newPassword}
                        setValue={setNewPassword}
                    />
                </Box>

                <Box mt={3}>
                    <Typography mb={1} sx={{
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                        fontWeight: 500,
                        color: theme.vars.palette.text.main
                    }}>
                        Confirmar Contraseña
                    </Typography>
                    <CustomInput
                        placeholder="Confirme la nueva contraseña"
                        width="100%"
                        password={true}
                        value={confirmPassword}
                        setValue={setConfirmPassword}
                    />
                </Box>

                <Box mt={4} width="100%">
                    <PrimaryButton
                        click={handleChangePassword}
                        text="Cambiar Contraseña"
                        full={true}
                        loading={loading}
                        desactived={!newPassword || !confirmPassword}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default ChangePasswordRequired;
